export default __webpack_public_path__ + "static/media/Gauntlets of the Victorious Elite.c8b0f8b7.jpg";